import React, { useState } from 'react';
import { steps } from './Login.utils';

const Login: React.FC = () => {
  const phoneNumber = '+44 3432 44324';
  const [currentStepIdx, setCurrentStepIdx] = useState<number>(1);

  const moveToNextStep = () => {
    setCurrentStepIdx((idx) => Math.min(idx + 1, steps.length));
  };

  return (
    <>
      {steps.map(
        ({ stepId, Component }) =>
          currentStepIdx === stepId && (
            <Component
              key={stepId}
              onGoNext={moveToNextStep}
              phoneNumber={phoneNumber}
            />
          )
      )}
    </>
  );
};

export default Login;
